module.exports = __webpack_public_path__ + "img/no-events.3d5ad5da.png";